<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="d-flex flex-column">
        <img
          src="../../assets/logo_base.png"
          style="width: 241px; height: 56px"
        />
        <a
          class="m-0 mt-3"
          style="cursor: pointer"
          href="https://lcsistemas.com.br/sobre/#trabalhe-conosco"
          target="_blank"
        >
          <svg
            style="color: #F7A900; font-size: 20px; margin-left: 4px;"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="user-check"
            class="svg-inline--fa fa-user-check fa-w-20"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
          >
            <path
              fill="currentColor"
              d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
            ></path>
          </svg>
          Trabalhe na LC Sistemas
        </a>
        <a class="m-0 mt-2">
          <svg
            style="color: #F7A900; font-size: 20px; margin-left: 4px;"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="mail-bulk"
            class="svg-inline--fa fa-mail-bulk fa-w-18 mr-2"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
          >
            <path
              fill="currentColor"
              d="M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
            ></path></svg
          >contato@lcsistemas.com.br
        </a>
        <a class="m-0 mt-2" style="display: flex">
          <svg
            style="color: #F7A900; font-size: 20px; margin-left: 4px;"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="location-arrow"
            class="svg-inline--fa fa-location-arrow fa-w-16 mr-2"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
            ></path>
          </svg>
          <p style="line-height: 1">
            Av. Bernardo Sayão, nº 425, Silas<br />
            Freitas, Mãe do Rio/PA - 68675-000
          </p>
        </a>
      </div>
      <div
        style="margin-left: 50px; margin-right: 50px"
        class="
          d-none d-lg-flex
          flex-column
          align-items-center
          justify-content-center
        "
      >
        <ul class="d-flex flex-column align-items-center">
          <p><strong>MAPA</strong></p>
          <li>
            <a href="https://portal.lcsistemas.com.br/Login" target="blank"
              >Portal do representante</a
            >
          </li>
          <li>
            <a href="https://dashboard.lcsistemas.com.br/ " target="blank"
              >Dashboard</a
            >
          </li>
          <li>
            <a href="https://lcsistemas.com.br/sobre/" target="blank"
              >Sobre nós</a
            >
          </li>
          <li>
            <a href="https://lcsistemas.com.br/blog/" target="blank">Blog</a>
          </li>
          <li>
            <a href="https://lcsistemas.com.br/contato/" target="blank"
              >Contato</a
            >
          </li>
        </ul>
      </div>
      <div
        class="
          d-none d-lg-flex
          flex-column
          align-items-center
          justify-content-center
        "
      >
        <ul class="d-flex flex-column align-items-center">
          <p><strong>SEGMENTOS</strong></p>
          <li>
            <a href="https://lcsistemas.com.br/supermercado/" target="blank"
              >Supermercado</a
            >
          </li>
          <li>
            <a href="https://lcsistemas.com.br/farmacia/" target="blank"
              >Farmácia</a
            >
          </li>
          <li>
            <a href="https://lcsistemas.com.br/construcao/" target="blank"
              >Construção</a
            >
          </li>
          <li>
            <a href="https://lcsistemas.com.br/food/" target="blank"
              >Food Service</a
            >
          </li>
          <li>
            <a href="https://lcsistemas.com.br/confeccoes/" target="blank"
              >Confecções</a
            >
          </li>
          <li>
            <a href="https://lcsistemas.com.br/servicos/" target="blank"
              >Serviço</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom">
      <p class="m-0">
        Copyright ©️ 2021 - Todos os direitos reservados | Desenvolvido com 💛
        por LC Sistemas.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style>
.footer {
  /* position: relative;
  z-index: 5; */
  /* word-wrap: break-word; */
  /* grid-area: footer; */
  background-color: #414345;
  color: #fff;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-family: "Roboto", sans-serif;
  font-size: 1rem;
  /* justify-content: flex-start; */
}

.footer a {
  text-decoration: none;
  color: #ffff;
}

.footer a:hover {
  text-decoration: none;
  color: #fffe02;
}

/* .footer .banner {
  z-index: -1;
  opacity: .4;
  width: 100%;
  height: 100%;
  position: absolute;
  background: url(https://lirp-cdn.multiscreensite.com/a867ea3c/dms3rep/multi/opt/LC+SISTEMAS+-+CINZA+2-1920w.png)
    no-repeat center center fixed;
} */

.footer .footer-container {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
  padding: 25px 10px 10px 10px;
}

.footer .footer-container li {
  list-style-type: none;
}

.footer .footer-bottom {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 5px 10px 5px 10px;
  background: #000;
}

.footer h1 {
  font-size: 1.5rem;
}

/* .footer .link-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.footer .link-content .link {
  display: flex;
}

.footer .link-content .link a {
  border-radius: 15px;
  text-decoration: none;
  color: #414345;
  padding: 5px 15px;
  background: linear-gradient(to right, #f0c332, #fffe02);
  background-color: #ffc107;
}

.footer .link a:hover {
  background: #000;
  color: #f0c332;
} */
</style>